import React, { useState, useRef, useEffect } from "react";
import { Button, Image, Space } from "antd";
import * as TypeDTO from "../commons/typeDTO";
import * as Request from "../commons/request";
import * as String from "../commons/string";
import NoImage from "../assets/images/no_image.png";
import styles from "./ImagePreviewer.module.css";

function ImagePreviewer({
    title,
    value,
    enableAdd,
    disabled,
    resetImage,
    onImageChanged,
}: {
    title: string;
    value?: TypeDTO.RentImageDto;
    enableAdd?: boolean;
    disabled?: boolean;
    resetImage?: any;
    onImageChanged?: (file?: File, image?: string, isDelete?: boolean, imageId?: number) => void;
}) {
    const [imageFile, setImageFile] = useState<File>();
    const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);
    const [imageInfo, setImageInfo] = useState<string | undefined>(undefined);
    const [isDelete, setIsDelete] = useState<boolean>(false);
    const fileInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        value === undefined ? setImageSrc(undefined) : setImageSrc(Request.RENT_IMAGE_URL + value?.rentImageId);
        setIsDelete(false);
    }, [value]);

    useEffect(() => {
        value === undefined ? setImageSrc(undefined) : setImageSrc(Request.RENT_IMAGE_URL + value?.rentImageId);
        setIsDelete(false);
    }, [resetImage]);

    const encodeFileToBase64 = (fileBlob?: File) => {
        const reader = new FileReader();
        fileBlob !== undefined && reader.readAsDataURL(fileBlob);

        return new Promise((resolve) => {
            reader.onload = () => {
                if (reader !== null && reader.result !== null) {
                    setImageSrc(reader.result.toString());
                    resolve(reader.result.toString());
                }
            };
        });
    };

    function formatBytes(bytes: number) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = 2;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    const showFileBrowser = () => {
        if (fileInput !== null && fileInput.current !== null) fileInput.current.click();
    };

    const onDelete = () => {
        //setImageFile(undefined);
        setImageSrc(undefined);
        setIsDelete(true);
    };

    const onChange = () => {
        showFileBrowser();
        setIsDelete(false);
    };

    useEffect(() => {
        if (onImageChanged !== undefined) {
            onImageChanged(imageFile, imageSrc, isDelete, value?.rentImageId);
        }
    }, [imageSrc]);

    useEffect(() => {
        if (imageFile !== undefined && imageFile.name.length > 8) {
            const name = imageFile.name.substring(0, 8) + "…";
            setImageInfo(title + " (" + name + formatBytes(imageFile.size) + ")");
        } else {
            setImageInfo(title);
        }
    }, [imageFile]);

    return (
        <div className={styles.previewWrapper}>
            <input
                ref={fileInput}
                type="file"
                hidden={true}
                disabled={disabled}
                onChange={(e) => {
                    if (e.target.files !== null) {
                        setImageFile(e.target.files[0]);
                        encodeFileToBase64(e.target.files[0]);
                        e.target.value = "";
                    }
                }}
            />
            <div
                className={styles.preview}
                onClick={(e) => {
                    // console.log("e.target", e.target);
                    // console.log("e.currentTarget", e.currentTarget);

                    if (e.target === e.currentTarget) {
                        showFileBrowser();
                    }
                }}
            >
                <Image
                    style={{
                        height: "100%",
                        margin: "auto",
                        alignItems: "center",
                    }}
                    className={imageSrc !== undefined && imageSrc !== undefined ? styles.image : ""}
                    src={imageSrc !== undefined && imageSrc !== undefined ? imageSrc : NoImage}
                    alt="preview-img"
                    onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            showFileBrowser();
                        }
                    }}
                    preview={imageSrc === undefined ? false : true}
                />
                {!disabled ? (
                    <>
                        <Space className={styles.overlay}>
                            {(enableAdd === undefined || enableAdd) && <Button onClick={onChange}>추가</Button>}
                            {imageSrc !== undefined && imageSrc !== undefined && (
                                <Button danger onClick={onDelete}>
                                    삭제
                                </Button>
                            )}
                        </Space>
                        <div className={styles.background} />
                    </>
                ) : null}
            </div>
            <span>{title}</span>
        </div>
    );
}

export default ImagePreviewer;
